import { render, staticRenderFns } from "./PaymentFormAlerts.vue?vue&type=template&id=384aee6a&"
import script from "./PaymentFormAlerts.vue?vue&type=script&lang=js&"
export * from "./PaymentFormAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports